import React from 'react';
import { Button, Chip, colors } from '@dhis2/ui';
import { ArrowRight, ClipboardList, ListCheck, UserCog, Target } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const reportCards = [
  {
    title: 'Tasks Report',
    description: 'Review weekly task submissions, progress, achievements, and challenges by week.',
    route: '/tasks/tasks-report',
    icon: ListCheck,
    accent: '#0f766e',
  },
  {
    title: 'Objectives Report',
    description: 'Open your self objectives report and print your current objectives snapshot.',
    route: '/tasks/objectives-report',
    icon: ClipboardList,
    accent: '#1d4ed8',
  },
  {
    title: 'Leadership Report',
    description: 'View your self leadership management assessment and export it as PDF.',
    route: '/tasks/leadership-report',
    icon: UserCog,
    accent: '#7c3aed',
  },
  {
    title: 'Mid-Year Report',
    description: 'Open your self mid-year appraisal and print the completed review.',
    route: '/tasks/mid-year-report',
    icon: Target,
    accent: '#b45309',
  },
  {
    title: 'Year-End Report',
    description: 'Open your self year-end appraisal and export it as a printable report.',
    route: '/tasks/year-end-report',
    icon: Target,
    accent: '#be123c',
  },
];

const styles = {
  page: {
    maxWidth: '1360px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '22px',
  },
  hero: {
    background: 'linear-gradient(140deg, #032b1f 0%, #0f5132 50%, #f0b429 100%)',
    color: '#fff',
    borderRadius: '22px',
    padding: '28px',
    boxShadow: '0 20px 45px rgba(3, 43, 31, 0.22)',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '18px',
  },
};

export default function MyReportsPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <section style={styles.hero}>
        <Chip backgroundColor="rgba(255,255,255,0.18)" color="#fff">
          Staff Reporting Center
        </Chip>
        <h3 style={{ margin: '14px 0 10px', fontSize: '1.2rem', lineHeight: 1.05 }}>
          My Reports
        </h3>
        <p style={{ margin: 0, maxWidth: '860px', color: 'rgba(255,255,255,0.9)' }}>
          Use this center to open your self-service reports and export them with the browser print dialog as PDF.
        </p>
      </section>

      <section
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
          gap: '12px',
        }}
      >
        <Chip backgroundColor={colors.blue100} color={colors.blue900}>
          5 report areas
        </Chip>
        <Chip backgroundColor={colors.green100} color={colors.green900}>
          Self-service access
        </Chip>
        <Chip backgroundColor={colors.yellow100} color={colors.yellow900}>
          Print and PDF ready
        </Chip>
      </section>

      <section style={styles.grid}>
        {reportCards.map(({ title, description, route, icon: Icon, accent }) => (
          <article
            key={route}
            style={{
              backgroundColor: '#fff',
              borderRadius: '18px',
              padding: '22px',
              border: `1px solid ${colors.grey300}`,
              boxShadow: '0 10px 26px rgba(15, 23, 42, 0.07)',
              display: 'flex',
              flexDirection: 'column',
              gap: '14px',
            }}
          >
            <div
              style={{
                width: '52px',
                height: '52px',
                borderRadius: '14px',
                background: `${accent}1A`,
                color: accent,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Icon size={26} />
            </div>
            <div>
              <h3 style={{ margin: 0, color: '#102a43' }}>{title}</h3>
              <p style={{ margin: '8px 0 0', color: colors.grey800, lineHeight: 1.5 }}>
                {description}
              </p>
            </div>
            <div style={{ marginTop: 'auto' }}>
              <Button
                primary
                onClick={() => navigate(route)}
                icon={<ArrowRight size={16} />}
              >
                Open report
              </Button>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
